<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:planned_date" slot-scope="row">
                                {{row.item.started_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Toolbox Meeting" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            @setDefaultValue="setDefaultProject"
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <!-- <dropdown-locations 
                            label="Locations"
                            required
                            show-icon-required
                            multiple
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            v-model="modals.add.data.locations">
                        </dropdown-locations> -->
                        <dropdown-locations 
                            label="Location"
                            required
                            show-icon-required
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            v-model="modals.add.data.equipment">
                        </dropdown-locations>
                        <gofix-form-dropdown 
                            label="Topics" 
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.topics" 
                            :options="modals.add.options.topics">
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea 
                            label="Comment" 
                            :rows="5" 
                            v-model="modals.add.data.comment">
                        </gofix-form-input-textarea>
                        <dropdown-companies 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.company">
                        </dropdown-companies>
                        <dropdown-user-duties 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            role-name="Contractor Supervisor"
                            v-model="modals.add.data.contractor_supervisor_by">
                        </dropdown-user-duties>

                        <gofix-form-input-date
                            :minDate="new Date()"
                            required
                            show-icon-required
                            v-model="modals.add.data.planned_date"
                            label="Date">
                        </gofix-form-input-date>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="Start Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.start_time">
                                </gofix-form-input-time>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="End Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.end_time">
                                </gofix-form-input-time>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
import DropdownProjects from '../elements/DropdownProjects.vue'
import DropdownLocations from '../elements/DropdownLocations.vue'
import DropdownCompanies from '../elements/DropdownCompanies.vue'
import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
export default {
    name: 'toolbox-meeting-listing',
    components: {
        DropdownProjects,
        DropdownLocations,
        DropdownCompanies,
        DropdownUserDuties
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['toolbox_meeting_listing']));
        return {
            tableConfig:{
                name: 'safety-toolbox-meeting-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.toolbox_meeting, 'create'),
                    delete: this.$checkRole(this.$accessModule.toolbox_meeting, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Rejected', text: 'Rejected'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        checklist_template_id: null,
                        planned_date: null,
                        start_time: null,
                        end_time: null,
                        company: null,
                        contractor_supervisor_by: null,
                        topics: null,
                        comment: null,
                        // locations: null
                    },
                    options: {
                        topics: [],
                    }
                }
            },
            timer: {
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyToolboxMeetingItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },
        changeProject() {
            this.modals.add.options.contractor_supervisors = [];
            this.modals.add.data.contractor_supervisor_by = null;
            if(this.modals.add.data.project && this.modals.add.data.project.id) {
                this.getContractorSupervisors();
            }
        },
        clickToRowItem(item) {
           this.$router.push(`/v2/toolbox-meeting/${item.id}`)
        },
        newItem() {
            this.getTopics();
            this.modals.add.data = {
                project: null,
                equipment: null,
                checklist_template_id: null,
                date: null,
                start_time: null,
                end_time: null,
                company: null,
                contractor_supervisor_by: null,
                topics: null
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyToolboxMeetingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'toolbox_meeting'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },
        getTopics(){
            let filter = {reference_type: "Safety Toolbox Meeting Topics"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.topics = response.items;
                })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'project', name: 'Project'},
                    // { key: 'locations', name: 'Locations'},
                    { key: 'equipment', name: 'Location'},
                    { key: 'topics', name: 'Topics'},
                    { key: 'company', name: 'Subcontractor'},
                    { key: 'planned_date', name: 'Date'},
                    { key: 'start_time', name: 'Start Time'},
                    { key: 'end_time', name: 'End Time'},
                    
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    client_contract_id: this.modals.add.data.project.client_contract_id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.name,
                    // equipment_id: this.modals.add.data.equipment.equipment_id,
                    // equipment_lift_number: this.modals.add.data.equipment.equipment_lift_number,
                    // equipment_type: this.modals.add.data.equipment.equipment_type,
                    topics: this.modals.add.data.topics,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    contractor_supervisor_id: this.modals.add.data.contractor_supervisor_by ? this.modals.add.data.contractor_supervisor_by.user_id : null,
                    planned_date: this.modals.add.data.planned_date ? moment(this.modals.add.data.planned_date).format('YYYY-MM-DD') : null,
                    start_time: this.modals.add.data.start_time ? this.modals.add.data.start_time : null,
                    end_time: this.modals.add.data.end_time ? this.modals.add.data.end_time : null,
                    comment: this.modals.add.data.comment ? this.modals.add.data.comment : null,
                    // locations: this.modals.add.data.locations ? this.modals.add.data.locations : null
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyToolboxMeetingItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/toolbox-meeting/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'toolbox_meeting'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        setDefaultProject(val) {
            this.modals.add.data.project = val
        },
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>